import React from 'react';
import { useNavigate } from 'react-router-dom';


const MovieCard = ({ movie, onMovieClick }) => {
    const navigate = useNavigate();

    const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500';
  
    return (
        <div 
        className="card h-100" 
        onClick={() => navigate(`/movie/${movie.id}`)}
        style={{ cursor: 'pointer' }}      
      
      >
        <img
          src={movie.poster_path ? `${IMAGE_BASE_URL}${movie.poster_path}` : 'https://via.placeholder.com/500x750'}
          className="card-img-top"
          alt={movie.title}
        />
        <div className="card-body">
          <h5 className="card-title">{movie.title}</h5>
          <p className="card-text">Rating: {movie.vote_average?.toFixed(1)}</p>
        </div>
      </div>
    );
  };
export default MovieCard;


